import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IDownloadOrdemCompraArquivoUseCase } from "../../../presentation/useCases/read/download_ordem_compra_arquivo_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DownloadOrdemCompraArquivoUseCase
 */

export class DownloadOrdemCompraArquivoUseCase implements IDownloadOrdemCompraArquivoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async downloadOrdemCompraArquivo(
    idOrdemCompra: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository.downloadOrdemCompraArquivo(idOrdemCompra, nomeArquivo);
    await openInBlobInBlank(nomeArquivo, result);
  }
}
